import type { Role } from "./types";

const RANK: Record<Role, number> = { viewer: 0, editor: 1, admin: 2, owner: 3 };

/** True when `role` may do what `min` and above may do (Flashsuite ACCOUNTS.md section 5). */
export const atLeast = (role: Role, min: Role): boolean => RANK[role] >= RANK[min];
